








import {Component, Prop, Vue} from 'vue-property-decorator';
import {IShopCollection} from '@/models/IShopCollection';

@Component({})
export default class ShopCollectionTag extends Vue {
  @Prop() shopCollection!: IShopCollection;

  get color() {
    return 'black';
  }
}
